import React from "react";
import dayjs from "dayjs";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import { useGetExpensePlotDataQuery } from "state/api";
import Loader from "components/Loader";
import DatePickerComponent from "components/GraphDatePickerComponent";

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
      text: "Car Company Trends",
    },
    colors: {
      enabled: true,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
  },
  elements: {
    line: {
      tension: 0.3,
    },
  },
};

const ExpenseRangeGraph = () => {
  const [startDate, setStartDate] = React.useState(
    dayjs(new Date()).subtract(1, "month")
  );
  const [endDate, setEndDate] = React.useState(dayjs(new Date()));

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const { data: expensePlotData, isLoading } = useGetExpensePlotDataQuery({
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD"),
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col justify-center align-middle">
          <DatePickerComponent
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
          {/* <Bar
            data={{
              labels: expensePlotData?.labels,

              datasets: [
                {
                  label: "Expenses Amount",
                  data: expensePlotData?.data,
                  backgroundColor: "rgba(255, 0, 0, 0.4)",
                },
              ],
            }}
            options={options}
          /> */}
          <Line
            data={{
              labels: expensePlotData.labels,
              datasets: [
                {
                  label: "Expenses Amount",
                  borderColor: "#ff0000",
                  data: expensePlotData.data,
                  fill: {
                    target: "origin",
                    above: "rgba(255, 0, 0, 0.1)",
                  },
                },
              ],
            }}
            options={options}
          />
        </div>
      )}
    </>
  );
};

export default ExpenseRangeGraph;
